export class AlertInfoState {
  type: AlertTypeEnum;
  text: string;
  timeout: number; // 0 or less - never hide.
  id: number;
  canClose: boolean;
  eventCoordinates?: EventCoordinates;
}

export enum AlertTypeEnum {
  Warning,
  Info,
  Error,
  Success,
}

export interface EventCoordinates {
  x: number;
  y: number;
}

export class AlertTypeEnumHelper {
  static getAllValues(): AlertTypeEnum[] {
    const result: AlertTypeEnum[] = [];
    for (const val in AlertTypeEnum) {
      if (typeof AlertTypeEnum[val] === 'number') {
        // @ts-ignore
        result.push(AlertTypeEnum[val]);
      }
    }
    return result;
  }
}
